<template>
	<div class="content text-white">
		<div class="text-3.5xl mb-3">Validasi Identitas</div>
		<div class="text-xs mb-8">
			<Breadcrumbs />
		</div>

		<div class="grid grid-cols-70-30 gap-12">
			<div>
				<div class="card rounded-b-none p-5 mb-0.5">
					<Banner text="Pastikan data yang dimasukkan sesuai dengan data akun Anda" class="mb-5" />

					<div class="flex justify-center items-center flex--same-width mb-5">
						<label class="text-white" for="accountNumber">No KTP</label>
						<div>
							<input class="input w-full" type="text" placeholder="Masukkan nomor KTP" v-model="ktpNumber">
							<div class="text-xs mt-2">Catatan: 16 karakter dan angka</div>
							<div v-if="isIdNumberUnmatch" class="text-red text-xs mt-2">Nomor KTP tidak sesuai</div>
							<template v-for="item in idNumberErrors">
								<div :key="item" class="text-red text-xs mt-2">{{ item }}</div>
							</template>
						</div>
					</div>

					<div class="flex justify-center items-center flex--same-width mb-5">
						<label class="text-white" for="accountNumber">Nama Ibu Kandung</label>
						<div>
							<input class="input w-full" type="text" placeholder="Masukkan nama Ibu kandung" v-model="motherName">
							<div v-if="isMotherNameUnmatch" class="text-red text-xs mt-2">Nama ibu kandung tidak sesuai</div>
							<template v-for="item in motherNameErrors">
								<div :key="item" class="text-red text-xs mt-2">{{ item }}</div>
							</template>
						</div>
					</div>

				</div>

				<div class="card rounded-t-none p-5">
					<button class="btn c-btn-theme w-full" @click="validate()">Selanjutnya</button>
				</div>
			</div>

			<!-- Daftar Rekening Penerima -->
			<div>
				<div class="card rounded-b-none p-5 mb-0.5">
					<div class="text-sm">Nomor Rekening Diproses</div>
				</div>

				<div class="card rounded-t-none p-5">
					<template v-if="isLoadingBankListApproved">
						<div class="flex justify-center items-center">
							<Loader />
						</div>
					</template>

					<template v-else-if="isErrorBankListApproved">
						<div class="text-center mb-5">Gagal memuat data</div>
						<!-- button retry -->
						<button class="btn bg-theme w-full" @click="setBankListApproved">Retry</button>
					</template>

					<template v-else-if="bankListOnProcess.length < 1">
						<div class="text-xs text-center">Anda belum memiliki rekening bank yang sedang diproses</div>
					</template>

					<template v-else>
						<div v-for="item in bankListOnProcess" class="flex items-center gap-3 mb-5" :key="item._id">
							<div class="w-6">
								<!-- <LogoAbi size_prop="1.5em" /> -->
								<img :src="item.bankLogo" alt="Logo"/>
							</div>
							
							<div class="text-xs">
								<div class="mb-1">
									{{ item.accountName }}
									<span :class="[`${item.status == 'Verified' ? 'success' : 'gold'}`, 'ml-2']">
										{{ item.status }}
									</span>
								</div>
								<div>{{ item.bankName }} - {{ item.accountNumber }}</div>
							</div>
						</div>
					</template>

				</div>
			</div>

		</div>
		<router-view></router-view>
	</div>
</template>

<script>
import router from '../../router'

import useBankAccount from '../../composable/useBankAccount'

import Banner from '@/components/Banner.vue'
import Select from '@/components/ui/Select.vue'
import LogoAbi from '@/components/logo/LogoAbi.vue'
import Alert from '@/components/alert-component/AlertComponent.js'
import Breadcrumbs from '../../components/Breadcrumbs.vue'
import Loader from '../../components/Loader.vue'

export default {
	name: 'IdentityValidation',

	mixins: [useBankAccount],

	components: {
		Banner,
		Select,
		LogoAbi,
		Breadcrumbs,
		Loader
	},
	data() {
		return {
			ktpNumber: '',
			motherName: ''
		}
	},

	created() {
		this.setBankListApproved({
			status: "UNVERIFIED"
		})
	},

	methods: {
		open() {
			Alert.open({
				type: 'confirm',
				buttonConfirmPosition: 'vertical',
				title: 'Persetujuan Pengguna',
				description: 'Saya setuju untuk data terkait dengan nomor rekening yang saya masukkan untuk diverifikasi lebih lanjut oleh JFXGOLD X',
				onClose: () => {
					router.push('/add-bank-account/take-photo')
				}
			})
		},

		validate() {
			this.addIdentityValidation({
				"id_no": this.ktpNumber, // KTP number, numeric, 16 digits
				"mother_name": this.motherName // should same with RPED name, all chars will be uppercase formatted for matching
			})
		}
	},

	beforeRouteLeave(to, from, next) {
		if (to.name == 'Take Photo' || !this.$store.state.bankAccount.requestKeyAddBankAccount) {
			next()
			return
		}

		Alert.open({
			type: 'confirm',
			title: 'Apakah Anda Yakin ingin Keluar?',
			description: 'Jika Anda keluar, proses penambahan rekening akan dibatalkan (tidak dapat disimpan)',
			onConfirm: () => {
				this.$store.dispatch('bankAccount/removeAddBankAccountLocalStorage')
				next()
			},
			onDecline: () => {
				next(false)
			}
		})
	},
}
</script>

<style scoped>
.norek {
	margin-bottom: 0.125rem;
}

.card {
	background-color: var(--grey-4-color);
}

.logo-bagi {
	width: 1.5em;
	height: 1.5em;
}
</style>
